import { createApp } from 'vue'
import ColorPreview from './ColorPreview'

const el = '.kb-component--color-preview'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM) {
        const component = createApp(ColorPreview).use(Store)
        component.mount(el)
    }
}
